import { Directive } from '@angular/core';

import { Subject } from 'rxjs';
import { distinctUntilChanged, skip, takeUntil } from 'rxjs/operators';

import { SelectController } from '../select-controller.service';

@Directive({
  standalone: true,
  selector: 'rt-select2[withKeyNav]',
})
export class WithKeyNavDirective {
  private ngOnDestroy$ = new Subject<void>();

  constructor(public selectController: SelectController) {}

  public ngOnInit() {
    this.selectController.isOpen$
      .pipe(distinctUntilChanged(), skip(1), takeUntil(this.ngOnDestroy$))
      .subscribe(isOpen => {
        if (!isOpen) {
          const { value: items } = this.selectController.itemsToRender$;
          const { selected } = this.selectController.itemSelector;
          const index = Math.max(0, items.indexOf(selected!));

          this.selectController.navigation$.next({ type: 'item', index });
          this.selectController.focusTrigger$.next();
        }
      });

    this.selectController.keyDown$
      .pipe(takeUntil(this.ngOnDestroy$))
      .subscribe(event => this.handleKeyDown(event.key));
  }

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  // eslint-disable-next-line max-lines-per-function
  private handleKeyDown(key: string) {
    const { value: selection } = this.selectController.navigation$;
    const { value: filteredItems } = this.selectController.itemsToRender$;
    const { value: isDropdownOpened } = this.selectController.isOpen$;

    switch (key) {
      case 'ArrowDown': {
        if (!isDropdownOpened) return this.selectController.toggle(true);

        if (selection.index < filteredItems.length - 1) {
          const nextIndex = selection.index + 1;
          this.selectController.navigation$.next({ type: 'item', index: nextIndex });
          this.selectController.scrollToIndex(nextIndex);
        }
        break;
      }

      case 'ArrowUp': {
        if (!isDropdownOpened) return this.selectController.toggle(true);

        if (selection.index > 0) {
          const nextIndex = selection.index - 1;
          this.selectController.navigation$.next({ type: 'item', index: nextIndex });
          this.selectController.scrollToIndex(nextIndex);
        }
        break;
      }

      case 'Enter': {
        if (!isDropdownOpened) {
          return this.selectController.toggle(true);
        }

        this.selectController.select$.next(filteredItems[selection.index]);
        break;
      }

      case 'Escape': {
        if (!isDropdownOpened) return;

        this.selectController.toggle(false);
      }

      default:
        break;
    }
  }
}
